import { memo } from 'react'
import { Menu } from 'antd'

import { useMenu } from './useMenu'

function SidebarMenu() {
  const { items, currentKey, onMenuItemClick } = useMenu()

  return (
    <Menu
      className="sidebar__menu"
      items={items}
      mode="inline"
      selectedKeys={[currentKey]}
      onClick={onMenuItemClick}
    />
  )
}

export default memo(SidebarMenu)
